export function useJwtQueryParams(search: string): null | string {
	const searchParams = new URLSearchParams(search)
	searchParams.forEach((value, key) => {
		if (key === 'wb-jwt') {
			localStorage.setItem('wb-jwt', value)
			return value
		}
	})
	return null
}
